import React, { useState } from 'react';
import DeleteConfirm from '../../../components/DeleteConfirm';
import ENUMS from '../../../enums';

export default props => {
  const [displayDeleteConfirm, setDisplayDeleteConfirm] = useState(false);
  const [selectedItemKeyForDelete, setSelectedItemKeyForDelete] = useState(false);
  const [selectedItemTitleForDelete, setSelectedItemTitleForDelete] = useState('');

  const deleteAlreadySelectedItem = () => {
    props.deleteContactItem(selectedItemKeyForDelete);
    setDisplayDeleteConfirm(false);
    setSelectedItemKeyForDelete(null);
  };

  const onDeleteItem = (itemKey, value) => {
    setDisplayDeleteConfirm(true);
    setSelectedItemKeyForDelete(itemKey);
    setSelectedItemTitleForDelete('آیتم تماس با مقدار ' + value);
  };

  const onEditItem = itemKey => {
    props.displayEditContactItemModal(itemKey);
  };

  const closeDeleteContactItemModal = () => {
    setDisplayDeleteConfirm(false);
    setSelectedItemKeyForDelete(null);
  };

  const renderIconName = name => {
    switch (name) {
      case ENUMS.CONTACT_TYPES.values.EMAIL:
        return 'fal fa-envelope-open';
      case ENUMS.CONTACT_TYPES.values.INSTAGRAM:
        return 'fab fa-instagram';
      case ENUMS.CONTACT_TYPES.values.WEBSITE:
        return 'fal fa-browser';
      case ENUMS.CONTACT_TYPES.values.PHONE:
        return 'fal fa-phone';
      case ENUMS.CONTACT_TYPES.values.MOBILE:
        return 'fal fa-mobile-alt';
      default:
        break;
    }
  };

  return (
    <div className={props.className}>
      <table className="table table-hover table-striped table-bordered" width="100">
        <thead>
          <tr>
            <th className="text-center text-muted">{locales('fields.row')}</th>
            <th className="text-center text-muted">{locales('fields.contact.type')}</th>
            <th className="text-center text-muted">{locales('fields.contact.value')}</th>
            <th className="text-center text-muted" colSpan="2"></th>
          </tr>
        </thead>
        <tbody>
          {props.contacts &&
            props.contacts
              .sort((a, b) => {
                if (a.type > b.type) {
                  return a;
                } else {
                  return b;
                }
              })
              .map((item, index) => {
                return (
                  <tr key={item.itemKey}>
                    <th className="text-center">{index + 1}</th>
                    <th className="text-center">
                      <i className={`${renderIconName(item.type)} px-1`} />
                    </th>
                    <th className="text-center">{item.value}</th>
                    <th className="text-center">
                      <i onClick={e => onEditItem(item.itemKey)} className="fal fa-edit pointer" />
                    </th>
                    <th className="text-center">
                      <i onClick={e => onDeleteItem(item.itemKey, item.value)} className="fal fa-trash pointer" />
                    </th>
                  </tr>
                );
              })}
          <tr>
            <td colSpan="4"></td>
            <td>
              <i
                className="fal fa-plus-circle p-1 pointer"
                onClick={props.displayContactModal}
                title={locales('labels.add.new.contact.item')}
              />
            </td>
          </tr>
        </tbody>
      </table>
      {displayDeleteConfirm && (
        <DeleteConfirm
          isOpen={displayDeleteConfirm}
          itemGroupTitle={locales('titles.contact.item')}
          itemKey={selectedItemKeyForDelete}
          itemTitle={selectedItemTitleForDelete}
          onConfirm={deleteAlreadySelectedItem}
          closeModal={closeDeleteContactItemModal}
        />
      )}
    </div>
  );
};
